import { z } from 'zod'
import { AUTH_PASSWORD_MIN_LENGTH } from '@chillout/core'

type Translate = (key: string) => string

export function signInSchema(t: Translate) {
  return z.object({
    email: z.string()
      .min(1, { message: t('adminAuth.emailRequiredError') })
      .email({ message: t('adminAuth.emailInvalidError') }),
    password: z.string().min(1, { message: t('adminAuth.passwordRequiredError') }),
  })
}

export function forgotPasswordSchema(t: Translate) {
  return z.object({
    email: z.string()
      .min(1, { message: t('adminAuth.emailRequiredError') })
      .email({ message: t('adminAuth.emailInvalidError') }),
  })
}

export function createPasswordSchema(t: Translate) {
  return z.object({
    password: z.string()
      .min(1, { message: t('adminAuth.passwordRequiredError') })
      .min(AUTH_PASSWORD_MIN_LENGTH, { message: t('adminAuth.passwordTooShortError') }),
    confirmPassword: z.string()
      .min(1, { message: t('adminAuth.confirmPasswordRequiredError') }),
  }).refine((data) => data.password === data.confirmPassword, {
    message: t('adminAuth.passwordsDoNotMatchError'),
    path: ['confirmPassword'],
  })
}